import {ReactNode, Ref} from "react";
import {useFormContext} from "react-hook-form";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
// @ts-expect-error no ts support yet
import TransactionScriptEditor from "@/legacy/transaction/TransactionScriptEditor.jsx";
import {ServiceField} from "@/lib/constants/service.ts";
import {ServiceDefinition, StepDefinitions} from "@/lib/types/checks.ts";

interface Props {
  svc: ServiceDefinition;
  stepsDef: StepDefinitions;
  txnRef: Ref<ReactNode>;
  pagespeedReportURL?: string;
  onOpenRecorder?: () => void;
}

export const TransactionScriptEditorField = ({svc, txnRef, stepsDef, pagespeedReportURL, onOpenRecorder}: Props) => {
  const {user, userHasFeature} = useCurrentUserContext();
  const {
    setValue,
    watch,
    clearErrors,
    trigger,
    formState: {errors},
  } = useFormContext();
  const value = watch(ServiceField.SCRIPT);
  const fieldError = errors[ServiceField.SCRIPT]?.message;
  return (
    <TransactionScriptEditor
      ref={txnRef}
      monitoringServiceType={svc.service_type}
      pagespeedReportURL={pagespeedReportURL}
      onOpenRecorder={onOpenRecorder}
      isVisible={svc.has_transaction_script}
      validationErrors={fieldError ? [fieldError] : fieldError}
      stepDefs={stepsDef}
      mspScript={value}
      onChange={(script: object[]) => {
        setValue(ServiceField.SCRIPT, script, {shouldDirty: true});
        if (fieldError) {
          clearErrors(ServiceField.SCRIPT);
          trigger(ServiceField.SCRIPT);
        }
      }}
      enableTxnRecorder={userHasFeature("transaction-recorder")}
      enabledFeatureFlags={(user?.account?.feature_flags || []).map((flag) => flag.name)}
    />
  );
};
